jQuery(document).ready(function ($) {

  $('#gls-popup').ready(function () {
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    let localization = ca[0].split('=')[1];

    setTimeout(function () {
      jQuery('div[data-name="United States"]').trigger('click')
    }, 2000);

  })

  $('.footer-copyright nav.links select').on('change', function () {
    window.location.href = jQuery(this).val()
  });

  setTimeout(() => {
    // jQuery('.floating-add-tocart .product-form__input.product-form__quantity + div > product-form button span').text(jQuery('.product__info-container.product__column-sticky .product-form__input.product-form__quantity + div > product-form button span').text())
    // jQuery('button.product-form__submit:not(.restock-rocket-preorder-button) > span:not(.Add-tocart-text)').css({'display': 'none'});
    //   jQuery('button.product-form__submit:not(.restock-rocket-preorder-button) span.Add-tocart-text').removeClass('hidden');
  }, 2000);

  // Helper function to get current variant's compare-at price from Shopify data.
  // When a pack-size selector is active (selling-plan-driven packs), multiplies
  // the 1-Pack compare-at price by the selected pack count so downstream price
  // displays (One-Time, Subscribe & Save) reflect the total for the chosen pack.
  function getCurrentVariantCompareAtPrice() {
    try {
      const packCount = (typeof window._currentPackCount === 'number' && window._currentPackCount > 0)
        ? window._currentPackCount
        : 1;

      // Method 0 (BEST): Use variant from the most recent variantChange event
      if (window._currentVariantFromEvent && window._currentVariantFromEvent.compare_at_price) {
        const priceInDollars = window._currentVariantFromEvent.compare_at_price / 100;
        return priceInDollars * packCount;
      }

      // Method 1: Get variant ID from hidden input (more reliable after variant change)
      let variantId = null;
      const variantInput = document.querySelector('input[name="id"][type="hidden"], select[name="id"]');
      if (variantInput && variantInput.value) {
        variantId = parseInt(variantInput.value, 10);
      }

      // Method 2: Get variant ID from URL (fallback)
      if (!variantId) {
        const urlParams = new URLSearchParams(window.location.search);
        const urlVariantId = urlParams.get('variant');
        if (urlVariantId) {
          variantId = parseInt(urlVariantId, 10);
        }
      }

      // Method 3: Get from product-variant-id input
      if (!variantId) {
        const productVariantInput = document.querySelector('.product-variant-id');
        if (productVariantInput && productVariantInput.value) {
          variantId = parseInt(productVariantInput.value, 10);
        }
      }

      if (!variantId) {
        // No variant-selects on page (pack-size-selector flow) — fall back to
        // the base 1-Pack price provided by the selector element.
        if (window._onePackBasePrice) {
          return (window._onePackBasePrice / 100) * packCount;
        }
        return null;
      }

      // Look up variant in the full variants array
      const variantsScript = document.querySelector('variant-selects script[type="application/json"]:not([data-selected-variant])');
      if (variantsScript) {
        const allVariants = JSON.parse(variantsScript.textContent);
        if (Array.isArray(allVariants)) {
          const currentVariant = allVariants.find(v => v.id === variantId);
          if (currentVariant && currentVariant.compare_at_price) {
            const priceInDollars = currentVariant.compare_at_price / 100;
            return priceInDollars * packCount;
          }
        }
      }

      // Fallback: try the selected variant script (for initial load)
      const selectedVariantScript = document.querySelector('script[data-selected-variant]');
      if (selectedVariantScript) {
        const selectedVariant = JSON.parse(selectedVariantScript.textContent);
        if (selectedVariant && selectedVariant.compare_at_price) {
          const priceInDollars = selectedVariant.compare_at_price / 100;
          return priceInDollars * packCount;
        }
      }

      // Final fallback: use the 1-Pack base price from pack-size-selector
      if (window._onePackBasePrice) {
        return (window._onePackBasePrice / 100) * packCount;
      }
    } catch (e) {
      // Silent error handling for production
    }
    return null;
  }

  // Function to show the crossed-out compare-at price for One-Time Purchase
  // Updated to show discounted prices for multi-pack one-time purchases
  function showOneTimeComparePrice() {
    const oneTimePriceEl = document.querySelector('[data-stayai-onetime-price]');
    if (!oneTimePriceEl) {
      return;
    }

    // Prevent GTranslate from wrapping price text in <font> tags
    oneTimePriceEl.classList.add('notranslate');
    oneTimePriceEl.setAttribute('translate', 'no');

    // Clean up any existing GTranslate <font> wrapper elements.
    // GTranslate wraps translated text in <font><font>text</font></font>,
    // which causes price duplication when our code adds new text nodes.
    var gtFontEl;
    while ((gtFontEl = oneTimePriceEl.querySelector('font'))) {
      // Unwrap: move children out of the <font>, then remove the empty <font>
      while (gtFontEl.firstChild) {
        gtFontEl.parentNode.insertBefore(gtFontEl.firstChild, gtFontEl);
      }
      gtFontEl.remove();
    }
    // Merge adjacent text nodes created by unwrapping
    oneTimePriceEl.normalize();

    // Prevent multiple rapid updates
    if (oneTimePriceEl.dataset.updating === 'true') return;

    // Helper to mark fullPrice as validated so CSS will show it
    const markFullPriceAsValidated = () => {
      const fullPriceEl = oneTimePriceEl.querySelector('.fullPrice');
      if (fullPriceEl) {
        fullPriceEl.classList.add('js-price-updated');
      }
    };

    // Get current pack count from selected variant
    const packCount = getCurrentPackCount();

    // Get the variant's compare_at_price (which is now the same as price = full price)
    const fullPrice = getCurrentVariantCompareAtPrice() || getCurrentVariantPrice();

    // Get current pack count and discount percentage
    const discountPercent = ONE_TIME_PERCENTAGES[packCount] || 0;

    // Find or create the price display elements
    let mainPriceEl = oneTimePriceEl.querySelector('.js-onetime-discounted-price');
    let compareEl = oneTimePriceEl.querySelector('s.js-onetime-compare-price');

    // If no discount (1-pack), do nothing - let Stay AI handle the display natively
    if (discountPercent === 0) {
      // Just remove any custom elements we may have added previously
      // But don't clear the container - let Stay AI show its native price
      if (mainPriceEl) mainPriceEl.remove();
      if (compareEl) compareEl.remove();

      // Show ALL hidden Stay AI elements that we may have hidden before
      Array.from(oneTimePriceEl.children).forEach(function(child) {
        // Show all elements that are NOT our custom elements
        if (!child.classList.contains('js-onetime-discounted-price') &&
            !child.classList.contains('js-onetime-compare-price')) {
          child.style.display = '';
        }
      });

      // Force the 1-pack one-time price to the current variant full price
      if (fullPrice) {
        const currencySymbol = detectCurrencySymbol();
        const fullPriceText = currencySymbol + fullPrice.toFixed(2);
        const textNodes = Array.from(oneTimePriceEl.childNodes).filter(function(node) {
          return node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '';
        });
        textNodes.forEach(function(node) {
          node.parentNode.removeChild(node);
        });
        oneTimePriceEl.insertBefore(
          document.createTextNode(fullPriceText),
          oneTimePriceEl.firstChild
        );
      }

      markFullPriceAsValidated();
      // Don't modify Stay AI's content - just return and let it handle the display
      return;
    }

    // For 2-pack and 4-pack, we need to show: discountedPrice  fullPrice (strikethrough)
    if (!fullPrice) {
      markFullPriceAsValidated();
      return;
    }

    // Mark as updating to prevent re-entry during modification
    oneTimePriceEl.dataset.updating = 'true';

    // Calculate the discounted price
    const discountedPrice = fullPrice * (1 - discountPercent / 100);

    // Detect currency symbol from the page
    const currencySymbol = detectCurrencySymbol();

    // Capture and remove any native Stay AI text nodes (e.g., "€96.00") for 2/4-pack
    const textNodes = Array.from(oneTimePriceEl.childNodes).filter(function(node) {
      return node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '';
    });
    if (!oneTimePriceEl.dataset.stayaiOnetimeText && textNodes.length > 0) {
      oneTimePriceEl.dataset.stayaiOnetimeText = textNodes[0].textContent.trim();
    }
    textNodes.forEach(function(node) {
      node.parentNode.removeChild(node);
    });

    // Hide ALL Stay AI's native elements (don't remove them - we need them for 1-pack!)
    Array.from(oneTimePriceEl.children).forEach(function(child) {
      // Only hide elements that are NOT our custom elements
      if (!child.classList.contains('js-onetime-discounted-price') &&
          !child.classList.contains('js-onetime-compare-price')) {
        child.style.display = 'none';
      }
    });

    // Remove any existing custom elements we added previously
    if (mainPriceEl) mainPriceEl.remove();
    if (compareEl) compareEl.remove();

    // Create the main discounted price element (re-assign to existing variable)
    mainPriceEl = document.createElement('span');
    mainPriceEl.className = 'js-onetime-discounted-price';
    mainPriceEl.style.cssText = 'font-weight: bold;';
    mainPriceEl.textContent = currencySymbol + discountedPrice.toFixed(2);

    // Create the compare-at (strikethrough) price element (re-assign to existing variable)
    compareEl = document.createElement('s');
    compareEl.className = 'js-onetime-compare-price';
    compareEl.style.cssText = 'display: inline; text-decoration: line-through; color: rgba(0,0,0,0.5);';
    compareEl.textContent = currencySymbol + fullPrice.toFixed(2);

    // Insert our custom price elements
    oneTimePriceEl.appendChild(mainPriceEl);
    oneTimePriceEl.appendChild(compareEl);

    markFullPriceAsValidated();

    // Clear the updating flag after a short delay to allow DOM to settle
    setTimeout(function() {
      delete oneTimePriceEl.dataset.updating;
    }, 100);
  }

  /**
   * Get the current variant's price (not compare-at)
   */
  function getCurrentVariantPrice() {
    try {
      if (window._currentVariantFromEvent && window._currentVariantFromEvent.price) {
        return window._currentVariantFromEvent.price / 100;
      }

      const variantInput = document.querySelector('input[name="id"][type="hidden"], select[name="id"]');
      if (variantInput && variantInput.value) {
        const variantId = parseInt(variantInput.value, 10);
        const variantsScript = document.querySelector('variant-selects script[type="application/json"]:not([data-selected-variant])');
        if (variantsScript) {
          const allVariants = JSON.parse(variantsScript.textContent);
          if (Array.isArray(allVariants)) {
            const currentVariant = allVariants.find(v => v.id === variantId);
            if (currentVariant && currentVariant.price) {
              return currentVariant.price / 100;
            }
          }
        }
      }
    } catch (e) {
      // Silent error
    }
    return null;
  }

  /**
   * Detect currency symbol from the page
   */
  function detectCurrencySymbol() {
    // Try to find a price element on the page
    const priceEl = document.querySelector('.price-item--regular, .price .money, [data-stayai-onetime-price]');
    if (priceEl) {
      const text = priceEl.textContent || '';
      const match = text.match(/^([€$£¥])/);
      if (match) return match[1];
    }
    // Default to Euro for EU site
    return '€';
  }

  // Expose globally for cross-scope access
  window.showOneTimeComparePrice = showOneTimeComparePrice;

  // Function to update Subscribe & Save price display.
  // Stay AI renders the subscription price for the 1-Pack variant only.
  // For 2-Pack / 4-Pack we must override both the main price and the
  // compare-at (strikethrough) price ourselves, then restore Stay AI's
  // native display when the customer switches back to 1-Pack.
  function updateSubscribeAndSaveDisplay() {
    const subscriptionPriceEl = document.querySelector('[data-stayai-subscription-price]');
    if (!subscriptionPriceEl) return;

    // Prevent GTranslate from interfering with subscription prices
    subscriptionPriceEl.classList.add('notranslate');
    subscriptionPriceEl.setAttribute('translate', 'no');

    const packCount = getCurrentPackCount();
    const compareAtPrice = getCurrentVariantCompareAtPrice(); // already × packCount
    if (!compareAtPrice) return;

    const discountPercent = SUBSCRIPTION_PERCENTAGES[packCount] || 10;
    const subscriptionPrice = compareAtPrice * (1 - discountPercent / 100);
    const currencySymbol = detectCurrencySymbol();

    // Re-entry guard: only skip if our custom elements are still present.
    // If Stay AI wiped them, fall through to re-create.
    if (subscriptionPriceEl.dataset.updating === 'true') {
      if (subscriptionPriceEl.querySelector('.js-sub-discounted-price')) return;
    }
    subscriptionPriceEl.dataset.updating = 'true';

    // Clear Stay AI's native text nodes (e.g. "€43.20")
    Array.from(subscriptionPriceEl.childNodes).forEach(function(node) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
        node.textContent = '';
      }
    });
    Array.from(subscriptionPriceEl.children).forEach(function(child) {
      if (!child.classList.contains('js-sub-discounted-price') &&
          !child.classList.contains('js-sub-compare-price')) {
        child.style.display = 'none';
      }
    });

    const prevMain = subscriptionPriceEl.querySelector('.js-sub-discounted-price');
    const prevCompare = subscriptionPriceEl.querySelector('s.js-sub-compare-price');
    if (prevMain) prevMain.remove();
    if (prevCompare) prevCompare.remove();

    // Explicit flex order ensures discounted price renders before strikethrough,
    // even when Stay AI's CSS sets `order` on its own children.
    const mainPriceEl = document.createElement('span');
    mainPriceEl.className = 'js-sub-discounted-price';
    mainPriceEl.style.cssText = 'font-weight: bold; order: 1;';
    mainPriceEl.textContent = currencySymbol + subscriptionPrice.toFixed(2);

    const compareEl = document.createElement('s');
    compareEl.className = 'js-sub-compare-price';
    compareEl.style.cssText = 'display: inline; text-decoration: line-through; color: rgba(0,0,0,0.5); order: 2;';
    compareEl.textContent = currencySymbol + compareAtPrice.toFixed(2);

    subscriptionPriceEl.appendChild(mainPriceEl);
    subscriptionPriceEl.appendChild(compareEl);

    setTimeout(function() { delete subscriptionPriceEl.dataset.updating; }, 100);
  }

  // Subscription discount percentages by pack count
  const SUBSCRIPTION_PERCENTAGES = {
    1: 10,  // 1 Pack: 10% off
    2: 15,  // 2 Pack: 15% off
    4: 20   // 4 Pack: 20% off
  };

  // One-time purchase discount percentages by pack count
  const ONE_TIME_PERCENTAGES = {
    1: 0,   // 1 Pack: no discount
    2: 5,   // 2 Pack: 5% off
    4: 10   // 4 Pack: 10% off
  };

  /**
   * Extract pack count from variant title (e.g., "1 Pack" -> 1, "2 Pack" -> 2)
   */
  function extractPackCountFromVariant(variant) {
    if (!variant || !variant.title) return 1; // Default to 1 pack
    const match = variant.title.match(/(\d+)\s*Pack/i);
    return match ? parseInt(match[1], 10) : 1;
  }

  /**
   * Get the current pack count from selected variant
   */
  function getCurrentPackCount() {
    // Preferred: value set by pack-size-selector.js when the pack-size pill UI is active
    if (typeof window._currentPackCount === 'number' && window._currentPackCount > 0) {
      return window._currentPackCount;
    }

    // Legacy: derive from variantChange event when pack size is variant-driven
    if (window._currentVariantFromEvent) {
      return extractPackCountFromVariant(window._currentVariantFromEvent);
    }

    // Fallback: Check selected radio button in Pack Size fieldset
    const packSizeFieldsets = document.querySelectorAll('.product-form__input--pill');
    for (const fieldset of packSizeFieldsets) {
      const legend = fieldset.querySelector('legend');
      if (legend && legend.textContent.toLowerCase().includes('pack size')) {
        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          const label = fieldset.querySelector('label[for="' + checkedInput.id + '"]');
          if (label) {
            const match = label.textContent.match(/(\d+)\s*Pack/i);
            if (match) {
              return parseInt(match[1], 10);
            }
          }
        }
      }
    }

    // Default to 1 pack
    return 1;
  }

  /**
   * Replace Stay AI's dollar amount display with percentage for Subscribe & Save
   */
  function updateSubscriptionSavingsPercentage() {
    const packCount = getCurrentPackCount();
    const percentage = SUBSCRIPTION_PERCENTAGES[packCount] || 10;

    // Find Stay AI's subscription savings element
    // Based on the DOM structure, look for .subscription-savings class
    const savingsElements = document.querySelectorAll('.subscription-savings');

    savingsElements.forEach(el => {
      // Replace the dollar amount with percentage
      el.textContent = percentage + '%';
      // Add class so CSS knows to show this element (unhide it)
      el.classList.add('js-percentage-updated');
    });

    // Also check for span elements inside the subscription label
    const subscriptionLabel = document.querySelector('label[for="purchaseTypeSubscription"]');
    if (subscriptionLabel) {
      // Look for any span that contains a price-amount pattern or was previously updated.
      // Match on common currency symbols (€/$/£/¥) so this works for both EU and US.
      const allSpans = subscriptionLabel.querySelectorAll('span');
      allSpans.forEach(span => {
        const text = span.textContent.trim();
        if ((text.match(/^[€$£¥][\d,.]+$/) || span.classList.contains('js-percentage-updated'))
            && !span.classList.contains('js-sub-discounted-price')
            && !span.closest('[data-stayai-subscription-price]')) {
          span.textContent = percentage + '%';
          span.classList.add('js-percentage-updated');
        }
      });
    }
  }

  // Subscribe to Shopify's variant change event system
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    // Store the variant from the event for reliable lookup
    const eventVariant = event?.data?.variant;
    if (eventVariant) {
      window._currentVariantFromEvent = eventVariant;
    }

    // Use retry logic with increasing delays to ensure Stay AI has updated
    const tryUpdate = (attempt, delay) => {
      setTimeout(() => {
        showOneTimeComparePrice();
        updateSubscribeAndSaveDisplay();
        updateSubscriptionSavingsPercentage();
      }, delay);
    };

    // Try multiple times with increasing delays
    tryUpdate(1, 150);
    tryUpdate(2, 400);
    tryUpdate(3, 800);

    // Update Sticky Add to Cart Bar when variant changes
    updateStickyAddToCartBar(eventVariant);
  });

  // Pack-size selector (selling-plan-driven packs) fires this custom event.
  // Re-run the same price/percentage/sticky updates that run on a variant change
  // so the UI reflects the new pack count immediately.
  document.addEventListener('packSizeChanged', () => {
    setTimeout(() => {
      showOneTimeComparePrice();
      updateSubscribeAndSaveDisplay();
      updateSubscriptionSavingsPercentage();
      const variant = window._currentVariantFromEvent || (typeof getInitialVariant === 'function' ? getInitialVariant() : null);
      if (variant) {
        updateStickyAddToCartBar(variant);
      }
      if (typeof window.updateAllSavingsBadges === 'function') {
        window.updateAllSavingsBadges();
      }
    }, 0);
    setTimeout(() => {
      showOneTimeComparePrice();
      updateSubscribeAndSaveDisplay();
      updateSubscriptionSavingsPercentage();
    }, 150);
  });

  // Helper function to extract price HTML from Stay.ai price element
  function extractPriceHTML(priceElement) {
    if (!priceElement) return '';

    let comparePrice = '';
    let mainPrice = '';
    let priceHTML = '';

    // Prefer custom elements injected by our override logic, so we do not
    // accidentally read hidden native Stay.ai prices.
    const customMainEl = priceElement.querySelector('.js-sub-discounted-price, .js-onetime-discounted-price');
    const customCompareEl = priceElement.querySelector('s.js-sub-compare-price, s.js-onetime-compare-price');

    if (customMainEl || customCompareEl) {
      mainPrice = customMainEl ? customMainEl.textContent.trim() : '';
      comparePrice = customCompareEl ? customCompareEl.textContent.trim() : '';
    } else {
      // Fallback for native Stay.ai markup (e.g., 1-pack)
      const compareEl = priceElement.querySelector('s');
      if (compareEl) {
        comparePrice = compareEl.textContent.trim();
      }

      const allText = priceElement.textContent.trim();
      mainPrice = comparePrice ? allText.replace(comparePrice, '').trim() : allText;
    }

    if (comparePrice) {
      priceHTML += '<span class="sticky-add-to-cart-bar__compare-price"><s>' +
        comparePrice +
        '</s></span>';
    }

    if (mainPrice) {
      const hasSale = !!comparePrice;
      priceHTML += '<span class="sticky-add-to-cart-bar__current-price' +
        (hasSale ? ' sticky-add-to-cart-bar__current-price--sale' : '') +
        '">' + mainPrice + '</span>';
    }

    return priceHTML;
  }

  // Fallback function for base variant price when Stay.ai hasn't loaded
  function getBasePriceHTML(variant) {
    if (!variant) return '';

    let priceHTML = '';

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceHTML += '<span class="sticky-add-to-cart-bar__compare-price"><s>' +
        Shopify.formatMoney(variant.compare_at_price, window.theme?.moneyFormat || '€{{amount}}') +
        '</s></span>';
      priceHTML += '<span class="sticky-add-to-cart-bar__current-price sticky-add-to-cart-bar__current-price--sale">' +
        Shopify.formatMoney(variant.price, window.theme?.moneyFormat || '€{{amount}}') +
        '</span>';
    } else {
      priceHTML += '<span class="sticky-add-to-cart-bar__current-price">' +
        Shopify.formatMoney(variant.price, window.theme?.moneyFormat || '€{{amount}}') +
        '</span>';
    }

    return priceHTML;
  }

  // Function to update Sticky Add to Cart Bar on variant change
  function updateStickyAddToCartBar(variant) {
    if (!variant) return;

    const stickyBar = document.querySelector('.sticky-add-to-cart-bar');
    if (!stickyBar) return;

    // Update hidden variant ID input
    const variantInput = stickyBar.querySelector('.sticky-product-variant-id');
    if (variantInput) {
      variantInput.value = variant.id;
      if (variant.available) {
        variantInput.removeAttribute('disabled');
      } else {
        variantInput.setAttribute('disabled', 'disabled');
      }
    }

    // Update price display from Stay.ai widget
    const priceContainer = stickyBar.querySelector('.sticky-add-to-cart-bar__price');
    if (priceContainer) {
      // Determine which purchase type is selected
      const subscriptionRadio = document.getElementById('purchaseTypeSubscription');
      const oneTimeRadio = document.getElementById('purchaseTypeOneTime');
      const isSubscription = subscriptionRadio?.checked;
      const isOneTime = oneTimeRadio?.checked;

      let priceHTML = '';

      if (isSubscription) {
        // Read from Subscribe & Save price display
        const subscriptionPriceEl = document.querySelector('[data-stayai-subscription-price]');
        if (subscriptionPriceEl) {
          priceHTML = extractPriceHTML(subscriptionPriceEl);
        }
      } else if (isOneTime) {
        // Read from One-Time Purchase price display
        const oneTimePriceEl = document.querySelector('[data-stayai-onetime-price]');
        if (oneTimePriceEl) {
          priceHTML = extractPriceHTML(oneTimePriceEl);
        }
      }

      // Fallback: If neither is explicitly checked, detect the default
      if (!priceHTML) {
        // Check if subscription is the default (subscription radio exists but one-time is not checked)
        // Stay.ai typically defaults to subscription
        if (subscriptionRadio && !isOneTime) {
          // Subscription is likely the default - use subscription price
          const subscriptionPriceEl = document.querySelector('[data-stayai-subscription-price]');
          if (subscriptionPriceEl) {
            priceHTML = extractPriceHTML(subscriptionPriceEl);
          }
        }

        // If still no price, try one-time
        if (!priceHTML) {
          const oneTimePriceEl = document.querySelector('[data-stayai-onetime-price]');
          if (oneTimePriceEl) {
            priceHTML = extractPriceHTML(oneTimePriceEl);
          }
        }
      }

      // Final fallback to base variant price
      if (!priceHTML) {
        priceHTML = getBasePriceHTML(variant);
      }

      priceContainer.innerHTML = priceHTML;
    }

    // Update button state
    const submitBtn = stickyBar.querySelector('.sticky-add-to-cart-bar__submit');
    const buttonText = stickyBar.querySelector('.sticky-add-to-cart-bar__button-text');

    if (submitBtn && buttonText) {
      // Ensure sticky button has GTranslate-compatible spans
      if (!buttonText.querySelector('.sila-add-text')) {
        const originalNodes = Array.from(buttonText.childNodes);
        buttonText.innerHTML = '';

        const wrapperAdd = document.createElement('span');
        wrapperAdd.className = 'sila-add-text';
        originalNodes.forEach(node => wrapperAdd.appendChild(node));

        const wrapperSold = document.createElement('span');
        wrapperSold.className = 'sila-sold-text';
        wrapperSold.textContent = window.variantStrings?.soldOut || 'Sold out';
        wrapperSold.style.display = 'none';

        const wrapperUnavail = document.createElement('span');
        wrapperUnavail.className = 'sila-unavail-text';
        wrapperUnavail.textContent = window.variantStrings?.unavailable || 'Unavailable';
        wrapperUnavail.style.display = 'none';

        buttonText.appendChild(wrapperAdd);
        buttonText.appendChild(wrapperSold);
        buttonText.appendChild(wrapperUnavail);
      }

      const stickyAdd = buttonText.querySelector('.sila-add-text');
      const stickySold = buttonText.querySelector('.sila-sold-text');
      const stickyUnavail = buttonText.querySelector('.sila-unavail-text');

      if (stickyAdd && stickySold && stickyUnavail) {
        stickyAdd.style.display = 'none';
        stickySold.style.display = 'none';
        stickyUnavail.style.display = 'none';

        if (variant.available) {
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.remove('product_sold-out');
          stickyAdd.style.display = '';
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.classList.add('product_sold-out');
          stickySold.style.display = '';
        }
      }
    }

    // Update product image if variant has featured media
    if (variant.featured_media) {
      const imgElement = stickyBar.querySelector('.sticky-add-to-cart-bar__image img');
      if (imgElement && variant.featured_media.preview_image) {
        imgElement.src = variant.featured_media.preview_image.src.replace(/(\.[^.]+)$/, '_100x100$1');
        imgElement.alt = variant.featured_media.alt || variant.title;
      }
    }
  }

  // Expose globally for use in other scopes (e.g., Pack Savings IIFE)
  window.updateStickyAddToCartBar = updateStickyAddToCartBar;

  // Sync sticky bar button state with main button (for multi-pack inventory and other dynamic updates)
  function syncStickyButtonWithMain() {
    const mainBtn = document.querySelector('button[id^="ProductSubmitButton-"]:not([id^="StickySubmitButton-"])');
    const stickyBar = document.querySelector('.sticky-add-to-cart-bar');

    if (!mainBtn || !stickyBar) return;

    const stickyBtn = stickyBar.querySelector('.sticky-add-to-cart-bar__submit');
    const stickyBtnText = stickyBar.querySelector('.sticky-add-to-cart-bar__button-text');
    const stickyVariantInput = stickyBar.querySelector('.sticky-product-variant-id');
    const mainVariantInput = document.querySelector('input.product-variant-id[name="id"]');
    const stickyNotifyContainer = stickyBar.querySelector('.sticky-notify-me-container');
    const stickyProductForm = stickyBar.querySelector('product-form');

    if (!stickyBtn || !stickyBtnText) return;

    // Sync disabled state
    const isDisabled = mainBtn.disabled || mainBtn.hasAttribute('disabled');
    const mainBtnTextEl = mainBtn.querySelector('span:not(.loading__spinner):not(.Add-tocart-text)');

    // Ensure sticky button has GTranslate-compatible spans
    if (stickyBtnText && !stickyBtnText.querySelector('.sila-add-text')) {
      const originalNodes = Array.from(stickyBtnText.childNodes);
      stickyBtnText.innerHTML = '';

      const wrapperAdd = document.createElement('span');
      wrapperAdd.className = 'sila-add-text';
      originalNodes.forEach(node => wrapperAdd.appendChild(node));

      const wrapperSold = document.createElement('span');
      wrapperSold.className = 'sila-sold-text';
      wrapperSold.textContent = window.variantStrings?.soldOut || 'Sold out';
      wrapperSold.style.display = 'none';

      const wrapperUnavail = document.createElement('span');
      wrapperUnavail.className = 'sila-unavail-text';
      wrapperUnavail.textContent = window.variantStrings?.unavailable || 'Unavailable';
      wrapperUnavail.style.display = 'none';

      stickyBtnText.appendChild(wrapperAdd);
      stickyBtnText.appendChild(wrapperSold);
      stickyBtnText.appendChild(wrapperUnavail);
    }

    const stickyAdd = stickyBtnText.querySelector('.sila-add-text');
    const stickySold = stickyBtnText.querySelector('.sila-sold-text');
    const stickyUnavail = stickyBtnText.querySelector('.sila-unavail-text');

    // Read main button state by looking at its spans
    const mainSold = mainBtnTextEl?.querySelector('.sila-sold-text');
    const mainUnavail = mainBtnTextEl?.querySelector('.sila-unavail-text');

    const isShowingSoldOut = mainSold && mainSold.style.display !== 'none';
    const isShowingUnavail = mainUnavail && mainUnavail.style.display !== 'none';

    if (stickyAdd && stickySold && stickyUnavail) {
      stickyAdd.style.display = 'none';
      stickySold.style.display = 'none';
      stickyUnavail.style.display = 'none';

      if (isDisabled) {
        stickyBtn.setAttribute('disabled', 'disabled');
        stickyBtn.classList.add('product_sold-out');
        if (stickyVariantInput) stickyVariantInput.setAttribute('disabled', 'disabled');

        if (isShowingUnavail) {
          stickyUnavail.style.display = '';
        } else {
          stickySold.style.display = '';
        }
      } else {
        stickyBtn.removeAttribute('disabled');
        stickyBtn.classList.remove('product_sold-out');
        if (stickyVariantInput) stickyVariantInput.removeAttribute('disabled');
        stickyAdd.style.display = '';
      }
    }

    // Sync variant ID
    if (stickyVariantInput && mainVariantInput) {
      stickyVariantInput.value = mainVariantInput.value;
    }

    // Sync notify button visibility
    if (stickyNotifyContainer) {
      if (isDisabled) {
        stickyNotifyContainer.style.display = 'block';
        if (stickyProductForm) stickyProductForm.style.display = 'none';
      } else {
        stickyNotifyContainer.style.display = 'none';
        if (stickyProductForm) stickyProductForm.style.display = 'block';
      }
    }
  }

  // Expose globally for use in multi-pack-inventory.js
  window.syncStickyButtonWithMain = syncStickyButtonWithMain;

  // Set up MutationObserver to watch main button for changes
  function setupStickyButtonSync() {
    const mainBtn = document.querySelector('button[id^="ProductSubmitButton-"]:not([id^="StickySubmitButton-"])');
    if (!mainBtn) return;

    const observer = new MutationObserver((mutations) => {
      syncStickyButtonWithMain();
    });

    observer.observe(mainBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      childList: true,
      subtree: true
    });

    // Also watch the main variant input
    const mainVariantInput = document.querySelector('input.product-variant-id[name="id"]');
    if (mainVariantInput) {
      const inputObserver = new MutationObserver((mutations) => {
        syncStickyButtonWithMain();
      });
      inputObserver.observe(mainVariantInput, {
        attributes: true,
        attributeFilter: ['value', 'disabled']
      });
    }

    // Initial sync
    syncStickyButtonWithMain();
  }

  // Initialize sticky button sync after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupStickyButtonSync);
  } else {
    setupStickyButtonSync();
  }

  // Set up sticky bar to trigger main form submission instead of its own form
  // This ensures that Stay.ai's selling_plan is included when adding subscriptions to cart
  function setupStickyBarFormRedirect() {
    const stickyBtn = document.querySelector('.sticky-add-to-cart-bar__submit');
    if (!stickyBtn) return;

    stickyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Find the main Add to Cart button (not the sticky one)
      const mainBtn = document.querySelector('button[id^="ProductSubmitButton-"]:not([id^="StickySubmitButton-"])');
      if (mainBtn && !mainBtn.disabled) {
        // Trigger click on main button - this will include Stay.ai's selling_plan
        mainBtn.click();
      } else if (mainBtn && mainBtn.disabled) {
        // Button is disabled (sold out) - do nothing
      }
    });
  }

  // Initialize sticky bar form redirect after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupStickyBarFormRedirect);
  } else {
    setupStickyBarFormRedirect();
  }

  // Set up sticky notify button to trigger main Restock Rocket button
  function setupStickyNotifyButton() {
    const stickyNotifyBtn = document.querySelector('#sticky-notify-me-btn');
    if (!stickyNotifyBtn) return;

    stickyNotifyBtn.addEventListener('click', function(e) {
      e.preventDefault();

      // Find the main Restock Rocket notify button by ID (most reliable)
      let mainNotifyBtn = document.getElementById('notify-me-btn');

      // Fallback to class selectors if ID not found
      if (!mainNotifyBtn) {
        mainNotifyBtn = document.querySelector(
          '.restock-rocket-button-product, ' +
          '.restock-rocket-button, ' +
          'button[class*="restock-rocket"]'
        );
      }

      if (mainNotifyBtn) {
        // Store original display state
        const originalDisplay = mainNotifyBtn.style.display;
        const wasHidden = mainNotifyBtn.offsetParent === null;

        // Temporarily make visible if hidden (Restock Rocket may check visibility)
        if (wasHidden) {
          mainNotifyBtn.style.display = 'block';
          mainNotifyBtn.style.visibility = 'visible';
          mainNotifyBtn.style.opacity = '1';
        }

        // Use native click() method - this is what Restock Rocket expects
        try {
          mainNotifyBtn.click();
        } catch (err) {
          console.error('[StickyBar] Error clicking notify button:', err);
        }

        // Restore original display state after a brief delay
        if (wasHidden) {
          setTimeout(function() {
            mainNotifyBtn.style.display = originalDisplay;
            mainNotifyBtn.style.visibility = '';
            mainNotifyBtn.style.opacity = '';
          }, 100);
        }
      } else {
        // Fallback: scroll to the main button area
        const productForm = document.querySelector('.product-form__buttons');
        if (productForm) {
          productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }

  // Initialize sticky notify button after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupStickyNotifyButton);
  } else {
    setupStickyNotifyButton();
  }

  // Helper function to get initial variant on page load when _currentVariantFromEvent is undefined
  function getInitialVariant() {
    // Try from event first (set by variant change)
    if (window._currentVariantFromEvent) {
      return window._currentVariantFromEvent;
    }

    // Fallback: Get variant ID from main form's hidden input
    const mainVariantInput = document.querySelector('input.product-variant-id[name="id"]');
    if (mainVariantInput && mainVariantInput.value) {
      // Create minimal variant object for price update
      return {
        id: parseInt(mainVariantInput.value, 10),
        available: !mainVariantInput.disabled
      };
    }

    return null;
  }

  // Expose globally for use in other scopes (e.g., Pack Savings IIFE)
  window.getInitialVariant = getInitialVariant;

  // Mark Stay AI price elements as notranslate to prevent GTranslate
  // from wrapping price text in <font> tags and causing price duplication
  function markPriceElementsNoTranslate() {
    document.querySelectorAll(
      '[data-stayai-onetime-price], [data-stayai-subscription-price]'
    ).forEach(function(el) {
      el.classList.add('notranslate');
      el.setAttribute('translate', 'no');
    });
  }
  // Run notranslate marking early and repeatedly until Stay AI loads
  setTimeout(markPriceElementsNoTranslate, 0);
  setTimeout(markPriceElementsNoTranslate, 100);
  setTimeout(markPriceElementsNoTranslate, 300);
  setTimeout(markPriceElementsNoTranslate, 600);
  setTimeout(markPriceElementsNoTranslate, 1000);
  setTimeout(markPriceElementsNoTranslate, 1500);
  setTimeout(markPriceElementsNoTranslate, 2000);

  // Run after Stay AI loads (initial page load)
  // CSS hides elements by default, so no flash even if we run before Stay AI loads

  // Run one-time price update frequently to catch Stay AI ASAP
  setTimeout(showOneTimeComparePrice, 0);       // Immediate
  setTimeout(showOneTimeComparePrice, 100);     // Quick retry
  setTimeout(showOneTimeComparePrice, 300);     // After most DOM ready
  setTimeout(showOneTimeComparePrice, 600);     // After lazy loads
  setTimeout(showOneTimeComparePrice, 1000);    // Safety net
  setTimeout(showOneTimeComparePrice, 1500);    // Stay AI typical load time

  // Listen for one-time purchase option selection to update price display
  document.addEventListener('click', function(e) {
    if (e.target.matches('label[for="purchaseTypeOneTime"]') ||
        e.target.closest('label[for="purchaseTypeOneTime"]')) {
      setTimeout(() => window.showOneTimeComparePrice?.(), 100);
      setTimeout(() => window.showOneTimeComparePrice?.(), 300);
      setTimeout(() => window.showOneTimeComparePrice?.(), 500);
    }
  });

  // Listen for radio button change between subscription and one-time
  document.addEventListener('change', function(e) {
    if (e.target.id === 'purchaseTypeOneTime' || e.target.id === 'purchaseTypeSubscription') {
      setTimeout(() => window.showOneTimeComparePrice?.(), 100);
      setTimeout(() => window.showOneTimeComparePrice?.(), 300);
    }
  });

  // Run subscription display update frequently to mark fullPrice as validated ASAP
  setTimeout(updateSubscribeAndSaveDisplay, 0);       // Immediate
  setTimeout(updateSubscribeAndSaveDisplay, 100);     // Quick retry
  setTimeout(updateSubscribeAndSaveDisplay, 300);     // After most DOM ready
  setTimeout(updateSubscribeAndSaveDisplay, 600);     // After lazy loads
  setTimeout(updateSubscribeAndSaveDisplay, 1000);    // Safety net
  setTimeout(updateSubscribeAndSaveDisplay, 1500);    // Stay AI typical load time

  // Run percentage update frequently to catch Stay AI as soon as it renders
  setTimeout(updateSubscriptionSavingsPercentage, 0);     // Immediate
  setTimeout(updateSubscriptionSavingsPercentage, 100);   // Quick retry
  setTimeout(updateSubscriptionSavingsPercentage, 300);   // After most DOM ready
  setTimeout(updateSubscriptionSavingsPercentage, 600);   // After lazy loads
  setTimeout(updateSubscriptionSavingsPercentage, 1000);  // Safety net
  setTimeout(updateSubscriptionSavingsPercentage, 1500);  // Stay AI typical load time

  // Update sticky bar price after Stay.ai loads to show accurate pricing
  function updateStickyBarFromStayAI() {
    // Check if Stay.ai has loaded (look for its price elements)
    const stayAiLoaded = document.querySelector('[data-stayai-onetime-price]') ||
                         document.querySelector('[data-stayai-subscription-price]');

    if (!stayAiLoaded) {
      // Stay.ai hasn't loaded yet, try again later
      return;
    }

    // Get current variant (use helper for initial page load)
    const variant = window._currentVariantFromEvent || getInitialVariant();
    if (variant) {
      updateStickyAddToCartBar(variant);
    }
  }

  // Run sticky bar update frequently to catch Stay.ai as soon as it renders
  setTimeout(updateStickyBarFromStayAI, 100);
  setTimeout(updateStickyBarFromStayAI, 300);
  setTimeout(updateStickyBarFromStayAI, 600);
  setTimeout(updateStickyBarFromStayAI, 1000);
  setTimeout(updateStickyBarFromStayAI, 1500);
  setTimeout(updateStickyBarFromStayAI, 2000);

  // MutationObserver to watch for Stay AI widget re-renders
  // Stay AI may dynamically update the subscription widget, so we need to re-apply percentages
  const stayAiObserver = new MutationObserver(function(mutations) {
    let shouldUpdate = false;

    mutations.forEach(function(mutation) {
      // Check if the mutation affects the subscription label or savings display
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const target = mutation.target;

        // Check if mutation is within Stay AI's subscription widget
        if (target.closest && (
          target.closest('label[for="purchaseTypeSubscription"]') ||
          target.closest('.stayai-purchase-label__wrapper') ||
          target.closest('.subscription-savings') ||
          target.classList?.contains('subscription-savings')
        )) {
          shouldUpdate = true;
        }

        // Also check added nodes for Stay AI elements
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.classList?.contains('subscription-savings') ||
                node.querySelector?.('.subscription-savings') ||
                node.closest?.('label[for="purchaseTypeSubscription"]')) {
              shouldUpdate = true;
            }
          }
        });
      }
    });

    if (shouldUpdate) {
      // Debounce: only update once per animation frame
      if (!window._subscriptionPercentageUpdatePending) {
        window._subscriptionPercentageUpdatePending = true;
        requestAnimationFrame(function() {
          // Re-inject Subscribe & Save price spans before Stay AI's re-render wipes them.
          updateSubscribeAndSaveDisplay();
          updateSubscriptionSavingsPercentage();

          // Also update sticky bar price when Stay.ai updates
          const variant = window._currentVariantFromEvent || (typeof getInitialVariant === 'function' ? getInitialVariant() : null);
          if (variant) {
            updateStickyAddToCartBar(variant);
          }

          window._subscriptionPercentageUpdatePending = false;
        });
      }
    }
  });

  // Start observing once Stay AI widget is likely loaded
  setTimeout(function() {
    const subscriptionWrapper = document.querySelector('.stayai-purchase-label__wrapper, label[for="purchaseTypeSubscription"]');
    if (subscriptionWrapper) {
      stayAiObserver.observe(subscriptionWrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } else {
      // Fallback: observe a broader container
      const productForm = document.querySelector('.product-form, .shopify-app-block');
      if (productForm) {
        stayAiObserver.observe(productForm, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }
  }, 2000);

  document.addEventListener('DOMContentLoaded', function () {
    var ul = document.querySelector('.page-cart .featured-collection-grid');
    var lis = Array.from(ul.getElementsByClassName('featured-product-item'));

    for (var i = lis.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      ul.insertBefore(lis[j], lis[i]);
    }
  });

  $('a[href*="#"]:not([href="#"])').click(function () {
    var offset = -200; // <-- change the value here
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top + offset
        }, 0);
        return false;
      }
    }
  });


  jQuery('.counter').counterUp({
    delay: 10,
    time: 1500
  });

  jQuery(".js-mobile-menu-trigger").click(function () {
    jQuery(".navigation-mobile").addClass("open");
  });

  jQuery(".js-mobile-close").click(function () {
    jQuery(".navigation-mobile").removeClass("open");
  });

  if (jQuery(".text-slider").length) {
    jQuery(".text-slider").slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      pauseOnHover: false,
      cssEase: 'linear',
      loop: true,
      centerMode: true
    });
  }

  jQuery(".accordion details").on("click", function () {
    jQuery(".accordion details")
      .not(jQuery(this).attr("id"))
      .removeAttr("open");
    if (jQuery(this).attr("open") == "undefined") {
      $(this).removeAttr("open");
    }
  });

  $(window).scroll(function () {
    var header = $(".shopify-section--header");
    var header = $("body:not(.page-product):not(.default) .shopify-section--header_new");
    var announcement = $(".announcement-bar-section");
    var window_offset = $(window).scrollTop();

    if (window_offset >= 20) {
      header.addClass("sticky_header");
      // hehome_headerader.css({ 'position': 'fixed', 'top': '39px' })
      // announcement.css('position', 'sticky')
    } else {
      header.removeClass("sticky_header");
      // home_header.css({ 'position': 'relative', 'top': '0' })
      // announcement.css('position', 'relative')
    }

    // Sticky Add to Cart Bar - Show/Hide based on main button position
    var stickyBar = $(".sticky-add-to-cart-bar");
    if (stickyBar.length > 0) {
      // Find the main Add to Cart button (first one that matches)
      var mainAddToCartBtn = $('button[id^="ProductSubmitButton-"]:not([id^="StickySubmitButton-"])').first();

      if (mainAddToCartBtn.length > 0) {
        var btnRect = mainAddToCartBtn[0].getBoundingClientRect();
        var btnBottomFromViewport = btnRect.bottom;

        // Show sticky bar when main button is scrolled out of view (above viewport)
        if (btnBottomFromViewport < 0) {
          stickyBar.addClass("sticky-add-to-cart-bar--visible");
        } else {
          stickyBar.removeClass("sticky-add-to-cart-bar--visible");
        }
      }
    }
  });

  jQuery(".columns:has(.has-overlay):not(.columns-1)").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: false,
    infinite: true,
    adaptiveHeight: true,
    loop: true,
    autoplaySpeed: 8000,
    arrows: false,
    dots: false,
    variableWidth: true,
    centerMode: true,
    mobileFirst: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: "unslick",
      },
    ],
  });

  jQuery(".section-two-column-table .two-column-section").slick({
    slidesToShow: 1,
    autoplay: false,
    infinite: true,
    loop: true,
    arrows: true,
    dots: false,
    variableWidth: true,
    mobileFirst: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  });

  // if($('.featured-products-slider').length){
  //   $('.featured-products-slider').slick({
  //     slidesToShow: 1,
  //       autoplay: false,
  //       infinite: false,
  //       loop: false,
  //       arrows: true,
  //       dots: false,
  //       centerMode: true,
  //       adaptiveHeight: true
  //   });
  // }


  // jQuery(".read-more-state").on("click", function () {
  //   var currentID = jQuery(this).attr("id");

  //   jQuery('.read-more-state:not("#' + currentID + '")').prop("checked", false);
  // });

  // jQuery(".overlay-heading svg").on("mouseover", function () {
  //   jQuery(this).parent().parent().addClass("active");
  // });

  // jQuery(".overlay-heading svg").on("mouseout", function () {
  //   jQuery(this).parent().parent().removeClass("active");
  // });

  jQuery(".choice-item .icon-action").on("click", function () {
    var dataBlock = jQuery(this).attr("data-block");
    jQuery(this).parent().toggleClass("active");
    jQuery(".choice-item .icon-action:not([data-block='" + dataBlock + "'])")
      .parent()
      .removeClass("active");

    jQuery(".choice-item:not(.active) .read-more-state").prop("checked", false);
    jQuery(".choice-item.active .read-more-state").prop("checked", true);
  });

  // jQuery(".choice-item.active .icon-action").on("click", function () {
  //   jQuery(this).parent().removeClass("active");
  // });

  // jQuery(".overlay-heading svg").on("click", function () {
  //   jQuery(this).parent().parent().addClass("active");
  //   jQuery(".overlay-content-item:not(" + this + ")").removeClass(".active");
  // });

  var current_handle = jQuery("#flavour-dropwdown").attr("data-current");
  jQuery(
    '#flavour-dropwdown a.flavour-item[data-handle="' + current_handle + '"]'
  ).addClass("active");
  jQuery("button.dropbtn").css("display", "none");

  jQuery(".flavour-item").on("click", function () {
    jQuery(".flavour-item").removeClass("active");
    jQuery(this).addClass("active");
    // jQuery('.mobile-only').attr('data-color', jQuery(this).attr('data-color') )
    jQuery('.product-flavour .mobile-only').css("background-color", jQuery(this).attr('data-color'));
    // jQuery(this).parent().addClass('selected')
    // jQuery('.flavour-item:not(' + this + ')').removeClass('.active')

    jQuery("button.dropbtn").css("display", "none");
  });

  jQuery(".product-flavour #flavour-dropwdown a.active").on(
    "click",
    function (e) {
      e.preventDefault();
      // jQuery('#flavour-dropwdown').addClass('show')
      jQuery("button.dropbtn").css("display", "block");
      jQuery('.product-flavour .mobile-only').css("background-color", 'white');
      setTimeout(() => {
        jQuery("button.dropbtn").trigger("click");
      }, 500);
    }
  );

  // jQuery('#flavour-dropwdown').on('click', function () {
  //     jQuery(this).addClass('show')
  //     // jQuery('button.dropbtn').css('display', 'block')
  //     jQuery('button.dropbtn').trigger('click')

  // })

  jQuery(".testimonial-section .testimonials").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 7000,
  });

  window.addEventListener("scroll", function () {
    if (!jQuery(".giraffly_phoneButtonPreview").is(":visible")) {
      jQuery(".buy-now-with-quantity").css("display", "flex");
    } else {
      jQuery(".buy-now-with-quantity").css("display", "none");
    }
  });


  if (jQuery('.section-multicolumn .columns[data-colum-style="true"]').length) {


    jQuery('.column').on('click', function () {
      if (jQuery(this).hasClass('active')) {
        jQuery(this).removeClass('active')
        jQuery(this).children('.icon-show').removeClass('hidden')
        jQuery(this).children('.icon-hide').addClass('hidden')
      } else {
        jQuery(this).addClass('active')
        jQuery(this).children('.icon-show').addClass('hidden')
        jQuery(this).children('.icon-hide').removeClass('hidden')
      }

    })

  }

  var slickoptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: false,
    infinite: false,
    adaptiveHeight: true,
    loop: false,
    autoplaySpeed: 8000,
    arrows: true,
    dots: false,
    variableWidth: true,
    centerMode: true,
    centerMode: true,
  };
  jQuery(".upsell-products").not('.slick-initialized').slick(slickoptions);

  jQuery('.accordion__content.rte').on('click', function (e) {
    e.preventDefault();
    return false;
  })

  jQuery('details summary').on('click', function (e) {

    if (jQuery(this).parent().is('[open]')) {
      e.preventDefault()
      jQuery(this).parent().removeAttr('open');
    }
  })

});

$(function () {
  const events = {
    click: "click",
  };

  const $button = $(
    ".section-multicolumn .dynamic-columns-section .column.has-overlay:has(.popup-content)"
  );

  $button.on(events.click, function (event) {
    var popupContent = jQuery(this).children(".popup-content").html();
    var dataOverlay = jQuery(this).attr("data-overlay");
    jQuery(this).addClass("current");

    const config = {
      title: dataOverlay,
      html: popupContent,
      showCloseButton: true,
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willClose: () => {
        jQuery(this).removeClass("current");
      },
    };

    // first variant
    sweetAlert.fire(config);

    // function callback(result) {
    //   if (result.value) {
    //     // second variant
    //     SweetAlert.fire("Yes", "Blah", "info");
    //   } else {
    //     // second variant
    //     SweetAlert.fire("No", "Blah", "info");
    //   }
    // }
  });
});

/**
 * Pack Size Savings Badges
 * Displays savings amount below each pack size option based on purchase type
 */
(function () {
  'use strict';

  // Discount configuration
  const DISCOUNT_CONFIG = {
    oneTime: {
      1: 0,     // 1 Pack: No discount
      2: 0.05,  // 2 Pack: 5% off
      4: 0.10   // 4 Pack: 10% off
    },
    subscription: {
      1: 0.10,  // 1 Pack: 10% off
      2: 0.15,  // 2 Pack: 15% off
      4: 0.20   // 4 Pack: 20% off
    }
  };

  /**
   * Get variant data by looking up the selected variant option
   */
  function getVariantByPackCount(packCount) {
    try {
      // Get all variants from Shopify data
      const variantsScripts = document.querySelectorAll('variant-selects script[type="application/json"]');
      for (let script of variantsScripts) {
        if (!script.hasAttribute('data-selected-variant')) {
          const variants = JSON.parse(script.textContent);
          if (Array.isArray(variants)) {
            // Find variant matching the pack count
            for (let variant of variants) {
              const variantText = (variant.title || '').toLowerCase();
              const packText = packCount + ' pack';

              // For pack count 1, also match just "Pack" (without number)
              if (packCount === 1) {
                if (variantText === 'pack' || variantText.includes(packText)) {
                  return variant;
                }
              } else if (variantText.includes(packText)) {
                return variant;
              }

              // Also check individual options
              if (variant.options) {
                for (let option of variant.options) {
                  const optionLower = (option || '').toLowerCase();
                  if (packCount === 1) {
                    if (optionLower === 'pack' || optionLower.includes(packText)) {
                      return variant;
                    }
                  } else if (optionLower.includes(packText)) {
                    return variant;
                  }
                }
              }
            }
          }
        }
      }
    } catch (e) {
      console.error('Error getting variant data:', e);
    }
    return null;
  }

  /**
   * Calculate savings for a given pack count and purchase type using actual variant data
   */
  function calculateSavings(packCount, isSubscription) {
    const discounts = isSubscription ? DISCOUNT_CONFIG.subscription : DISCOUNT_CONFIG.oneTime;
    const discountRate = discounts[packCount] || 0;

    // No discount rate = no savings to show
    if (discountRate === 0) return 0;

    const onePackPrice = window._onePackBasePrice;
    if (onePackPrice) {
      return Math.round(onePackPrice * packCount * discountRate);
    }

    return 0;
  }

  /**
   * Format cents to currency string
   */
  function formatCurrency(cents) {
    const amount = cents / 100;
    return '€' + amount.toFixed(2);
  }

  /**
   * Extract pack count from label text (e.g., "1 Pack" -> 1)
   */
  function extractPackCount(labelText) {
    const match = labelText.match(/(\d+)\s*Pack/i);
    return match ? parseInt(match[1], 10) : null;
  }

  /**
   * Check if subscription is currently selected (Stay AI specific)
   */
  function isSubscriptionSelected() {
    // Stay AI uses radio inputs with IDs: purchaseTypeSubscription and purchaseTypeOneTime
    const subscriptionRadio = document.getElementById('purchaseTypeSubscription');
    if (subscriptionRadio && subscriptionRadio.checked) {
      return true;
    }

    // Fallback: Check if one-time is NOT checked (subscription is default)
    const oneTimeRadio = document.getElementById('purchaseTypeOneTime');
    if (oneTimeRadio && !oneTimeRadio.checked) {
      // If one-time exists but is not checked, subscription might be selected
      const subscriptionExists = document.getElementById('purchaseTypeSubscription');
      if (subscriptionExists) {
        return subscriptionExists.checked;
      }
    }

    // Default to one-time if can't detect
    return false;
  }

  /**
   * Wrap input+label in a container for proper badge positioning
   */
  function wrapPackOption(input, label) {
    // Check if already wrapped
    if (label.closest('.pack-option-wrapper')) {
      return label.closest('.pack-option-wrapper');
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'pack-option-wrapper';

    // Insert wrapper before the input
    input.parentNode.insertBefore(wrapper, input);

    // Move input and label into wrapper
    wrapper.appendChild(input);
    wrapper.appendChild(label);

    return wrapper;
  }

  /**
   * Get the current flavor's color from the flavor selector
   */
  function getCurrentFlavorColor() {
    // Check for the current-product class on flavor items
    const currentFlavor = document.querySelector('.flavour-item.current-product, li.current-product');
    if (currentFlavor) {
      // Try data-color attribute first
      let color = currentFlavor.getAttribute('data-color');
      if (color) {
        return color;
      }

      // Try parsing the style attribute for --data-color CSS variable
      const styleAttr = currentFlavor.getAttribute('style');
      if (styleAttr) {
        const match = styleAttr.match(/--data-color:\s*([^;]+)/i);
        if (match && match[1]) {
          color = match[1].trim();
          return color;
        }
      }

      // Try getComputedStyle for CSS variable
      const computedColor = getComputedStyle(currentFlavor).getPropertyValue('--data-color');
      if (computedColor && computedColor.trim()) {
        return computedColor.trim();
      }
    }

    // Fallback: Check the flavour-items list for data-current and find matching item
    const flavourList = document.querySelector('ul.flavour-items');
    if (flavourList) {
      const currentHandle = flavourList.getAttribute('data-current');
      if (currentHandle) {
        const matchingItem = flavourList.querySelector('[data-handle="' + currentHandle + '"]');
        if (matchingItem) {
          // Try data-color attribute
          let color = matchingItem.getAttribute('data-color');
          if (color) {
            return color;
          }

          // Try parsing the style attribute
          const styleAttr = matchingItem.getAttribute('style');
          if (styleAttr) {
            const match = styleAttr.match(/--data-color:\s*([^;]+)/i);
            if (match && match[1]) {
              color = match[1].trim();
              return color;
            }
          }
        }
      }
    }

    // Fallback: Check CSS variable on the product-flavour container
    const productFlavour = document.querySelector('.product-flavour');
    if (productFlavour) {
      const computedStyle = getComputedStyle(productFlavour);
      const cssVarColor = computedStyle.getPropertyValue('--data-color');
      if (cssVarColor && cssVarColor.trim()) {
        return cssVarColor.trim();
      }
    }

    // Default color if nothing found
    return '#000000';
  }

  /**
   * Calculate relative luminance of a color and return appropriate text color
   * Returns black (#000000) for light backgrounds, white (#ffffff) for dark backgrounds
   */
  function getContrastTextColor(hexColor) {
    // Remove # if present
    const hex = hexColor.replace('#', '');

    // Parse RGB values
    let r, g, b;
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    } else {
      // Default to white text if can't parse
      return '#ffffff';
    }

    // Calculate relative luminance using the formula for perceived brightness
    // Using the formula: (0.299 * R + 0.587 * G + 0.114 * B)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // If luminance is greater than 0.5, use dark text; otherwise use light text
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }

  /**
   * Create or update a savings badge element for a specific pack option
   */
  function createSavingsBadge(wrapper, packCount, isSubscription, badgeColor) {
    const savings = calculateSavings(packCount, isSubscription);

    // Get or create badge
    let badge = wrapper.querySelector('.pack-savings-badge');

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'pack-savings-badge';
      wrapper.appendChild(badge);
    }

    // Apply the flavor color and appropriate text color for contrast
    if (badgeColor) {
      badge.style.backgroundColor = badgeColor;
      badge.style.color = getContrastTextColor(badgeColor);
    }

    // Update badge content and visibility
    if (savings > 0) {
      badge.textContent = 'Save ' + formatCurrency(savings);
      badge.classList.add('visible');
      badge.classList.remove('hidden');
    } else {
      badge.textContent = '';
      badge.classList.add('hidden');
      badge.classList.remove('visible');
    }

    return badge;
  }

  /**
   * Update all savings badges based on current purchase option
   */
  function updateAllSavingsBadges() {
    // Exposed as window.updateAllSavingsBadges (assignment below) so the
    // packSizeChanged event handler in the outer scope can re-run badges
    // when the customer switches pack size.
    const isSubscription = isSubscriptionSelected();
    const badgeColor = getCurrentFlavorColor();

    // Find Pack Size fieldset
    const packSizeFieldsets = document.querySelectorAll('.product-form__input--pill');

    packSizeFieldsets.forEach(function (fieldset) {
      const legend = fieldset.querySelector('legend');
      if (!legend || !legend.textContent.toLowerCase().includes('pack size')) {
        return;
      }

      // Find all radio inputs in this fieldset
      const inputs = fieldset.querySelectorAll('input[type="radio"]');

      inputs.forEach(function (input) {
        const label = fieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;

        const packCount = extractPackCount(label.textContent);
        if (!packCount) return;

        // Wrap the input and label if not already wrapped
        const wrapper = wrapPackOption(input, label);

        // Create/update the badge with the current flavor color
        createSavingsBadge(wrapper, packCount, isSubscription, badgeColor);
      });
    });
  }

  // Expose for cross-scope callers (e.g. packSizeChanged listener in outer scope)
  window.updateAllSavingsBadges = updateAllSavingsBadges;

  /**
   * Initialize savings badges and set up event listeners
   */
  function init() {
    // Initial render with a slight delay to ensure Stay AI is loaded
    setTimeout(updateAllSavingsBadges, 100);

    // Listen for Stay AI purchase option changes via the radio inputs
    document.addEventListener('change', function (e) {
      if (e.target.id === 'purchaseTypeSubscription' ||
        e.target.id === 'purchaseTypeOneTime' ||
        e.target.name === 'purchaseType') {
        setTimeout(updateAllSavingsBadges, 50);
        // Also update sticky bar price when purchase type changes
        setTimeout(function() {
          const variant = window._currentVariantFromEvent || window.getInitialVariant();
          if (variant) {
            window.updateStickyAddToCartBar(variant);
          }
        }, 150); // Delay to let Stay.ai update prices first
      }
    });

    // Listen for click events on Stay AI labels (for better coverage)
    document.addEventListener('click', function (e) {
      const label = e.target.closest('label[for="purchaseTypeSubscription"], label[for="purchaseTypeOneTime"]');
      if (label) {
        setTimeout(updateAllSavingsBadges, 100);
        // Also update sticky bar price when purchase type label is clicked
        setTimeout(function() {
          const variant = window._currentVariantFromEvent || window.getInitialVariant();
          if (variant) {
            window.updateStickyAddToCartBar(variant);
          }
        }, 200); // Longer delay for click events
      }

      // Also check for clicks on the stayai wrapper elements
      const stayaiOption = e.target.closest('.stayai-purchase-option, .stayai-purchase-label__wrapper');
      if (stayaiOption) {
        setTimeout(updateAllSavingsBadges, 100);
        // Also update sticky bar price when stayai element is clicked
        setTimeout(function() {
          const variant = window._currentVariantFromEvent || window.getInitialVariant();
          if (variant) {
            window.updateStickyAddToCartBar(variant);
          }
        }, 200);
      }

      // Listen for flavor changes
      const flavourItem = e.target.closest('.flavour-item, .flavour-items a');
      if (flavourItem) {
        // Longer delay for flavor changes as they may trigger page navigation or DOM updates
        setTimeout(updateAllSavingsBadges, 300);
      }
    });

    // Observe DOM for dynamically loaded content
    const observer = new MutationObserver(function (mutations) {
      let shouldUpdate = false;

      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          const hasNewContent = Array.from(mutation.addedNodes).some(function (node) {
            if (node.nodeType !== 1) return false;
            return node.classList?.contains('product-form__input--pill') ||
              node.querySelector?.('.product-form__input--pill') ||
              node.id === 'purchaseTypeSubscription' ||
              node.id === 'purchaseTypeOneTime';
          });
          if (hasNewContent) {
            shouldUpdate = true;
          }
        }
      });

      if (shouldUpdate) {
        setTimeout(updateAllSavingsBadges, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Additional delay to ensure Stay AI widget is fully loaded
    setTimeout(init, 500);
  }
})();

/**
 * Restock Rocket Button Visibility Manager
 * Hides "Notify Me When Available" buttons on collection pages and cart drawer
 * when a product has ANY available variants (only show when ALL variants are out of stock)
 * Exception: PDP pages are excluded - buttons show/hide based on selected variant
 */
(function () {
  'use strict';

  // Don't run this logic on product detail pages
  if (document.body.classList.contains('page-product')) {
    return;
  }

  /**
   * Check if a product has any available variants
   * @param {string} productHandle - The product handle
   * @returns {Promise<boolean>} - True if at least one variant is available
   */
  async function hasAvailableVariants(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        console.warn(`Failed to fetch product data for ${productHandle}`);
        return true; // Default to showing button if we can't fetch data
      }

      const productData = await response.json();

      // Check if any variant is available
      return productData.variants.some(variant => variant.available);
    } catch (error) {
      console.warn(`Error checking availability for ${productHandle}:`, error);
      return true; // Default to showing button on error
    }
  }

  /**
   * Hide Restock Rocket buttons for products with available variants
   */
  async function hideRestockButtonsForAvailableProducts() {
    // Find all Restock Rocket buttons on collection pages and cart drawer
    const restockButtons = document.querySelectorAll('.restock-rocket-button-collection');

    if (restockButtons.length === 0) {
      return;
    }

    for (const button of restockButtons) {
      // Skip if already processed
      if (button.dataset.availabilityChecked === 'true') {
        continue;
      }

      // Try to get product handle from various sources
      let productHandle = null;

      // Method 1: Check button's data attributes
      if (button.dataset.productHandle) {
        productHandle = button.dataset.productHandle;
      }

      // Method 2: Check parent card for product link
      if (!productHandle) {
        const productCard = button.closest('.card-wrapper, .upsell-product, .featured-product-item');
        if (productCard) {
          const productLink = productCard.querySelector('a[href*="/products/"]');
          if (productLink) {
            const match = productLink.href.match(/\/products\/([^?#]+)/);
            if (match) {
              productHandle = match[1];
            }
          }
        }
      }

      // Method 3: Check for product title link nearby
      if (!productHandle) {
        const cardInfo = button.closest('.card__information, .card__content');
        if (cardInfo) {
          const titleLink = cardInfo.querySelector('a.full-unstyled-link[href*="/products/"]');
          if (titleLink) {
            const match = titleLink.href.match(/\/products\/([^?#]+)/);
            if (match) {
              productHandle = match[1];
            }
          }
        }
      }

      if (!productHandle) {
        console.warn('Could not determine product handle for Restock Rocket button', button);
        button.dataset.availabilityChecked = 'true';
        continue;
      }

      // Check if product has available variants
      const hasStock = await hasAvailableVariants(productHandle);

      // Mark as checked to avoid re-processing
      button.dataset.availabilityChecked = 'true';

      if (hasStock) {
        // Product has available variants, hide the notify button
        button.style.display = 'none';
        button.setAttribute('aria-hidden', 'true');
      } else {
        // All variants are out of stock, show the notify button
        button.style.display = '';
        button.removeAttribute('aria-hidden');
      }
    }
  }

  /**
   * Initialize the Restock Rocket button manager
   */
  function init() {
    // Run initial check after a delay to ensure Restock Rocket has loaded
    setTimeout(hideRestockButtonsForAvailableProducts, 1000);
    setTimeout(hideRestockButtonsForAvailableProducts, 2000);

    // Watch for dynamically added content (cart drawer, AJAX updates)
    const observer = new MutationObserver(function (mutations) {
      let shouldCheck = false;

      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          const hasRestockButton = Array.from(mutation.addedNodes).some(function (node) {
            if (node.nodeType !== 1) return false;
            return node.classList?.contains('restock-rocket-button-collection') ||
              node.querySelector?.('.restock-rocket-button-collection');
          });
          if (hasRestockButton) {
            shouldCheck = true;
          }
        }
      });

      if (shouldCheck) {
        setTimeout(hideRestockButtonsForAvailableProducts, 500);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check when cart drawer opens
    document.addEventListener('click', function (e) {
      const cartTrigger = e.target.closest('[href*="/cart"], .cart-icon, #cart-icon-bubble');
      if (cartTrigger) {
        setTimeout(hideRestockButtonsForAvailableProducts, 1000);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Make featured product card image area clickable.
 * .card__media is position:absolute and the inner .card__content sits on top
 * with position:relative, so clicks on the image area hit .card__content, never
 * reaching .card__media. We listen on .card__inner instead (covers the full
 * image region) and navigate to the product link when clicked.
 * Applies to both .section-featured-products and .featured-collection-section.
 */
(function() {
  function initClickableCardMedia() {
    var productCards = document.querySelectorAll(
      '.section-featured-products .product-card-wrapper, .featured-collection-section .product-card-wrapper'
    );
    if (!productCards.length) return;

    productCards.forEach(function(card) {
      var cardInner = card.querySelector('.card__inner');
      var productLink = card.querySelector('.card__heading a');

      if (cardInner && productLink) {
        cardInner.style.cursor = 'pointer';
        cardInner.addEventListener('click', function(e) {
          // Don't hijack clicks on existing interactive elements
          if (e.target.closest('a, button, input, select, textarea')) return;
          window.location.href = productLink.href;
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClickableCardMedia);
  } else {
    initClickableCardMedia();
  }
})();
